import { createStore, combineReducers } from "redux";
import authReducer from "./reducers/authReducer";
import memberReducer from "./reducers/memberReducer";
import userReducer from "./reducers/userReducer";
import updateContributionReducer from "./reducers/updateContributionReducer";

const rootReducer = combineReducers({
  auth: authReducer,
  member: memberReducer,
  user: userReducer,
  updateContribution: updateContributionReducer,
});

const store = createStore(rootReducer);

export default store;
